export const recognizedPercentAddOnHeadings = [
  'percentaddon',
  'percent-addon',
  'percent addon',
  'procentuellttillã¤gg',
  'procentuellt-tillã¤gg',
  'procentuellt tillã¤gg',
  'procentuellttillägg',
  'procentuellt-tillägg',
  'procentuellt tillägg',
  'prosenttillegg',
  'prosent-tillegg',
  'prosent tillegg',
];
export const recognizedFixedAddOnHeadings = [
  'fixedaddon',
  'fixed-addon',
  'fixed addon',
  'krontillã¤gg',
  'kron-tillã¤gg',
  'kron tillã¤gg',
  'krontillägg',
  'kron-tillägg',
  'kron tillägg',
  'kronetillegg',
  'krone-tillegg',
  'krone tillegg',
];
export const recognizedFixedAddOnUnitHeadings = [
  'fixedaddonunit',
  'fixed-addon-unit',
  'fixed addon unit',
  'unit',
  'enhet',
];
